import { ClosablePopoverDriver } from './ClosablePopover/ClosablePopover.driver';
import { FloatingHelperContentDriver } from './FloatingHelperContent/FloatingHelperContent.driver';

export interface FloatingHelperDriver extends ClosablePopoverDriver {
  helperContent: FloatingHelperContentDriver;
  getHelperContentDriver: () => FloatingHelperContentDriver;
  hasCloseButton: () => boolean;
  clickCloseButton: () => void;
  getWidth: () => string;
}
